<template>
  <div class="view pa24">
    <div class="d-flex">
      <el-row :gutter="24">
        <el-col :xl="24" :lg="16" class="d-flex justify-content-between w100p">
          <div class="d-flex align-items-center">
            <el-input v-model="queryParam.name" class="mb10"
                      style="width: 240px"
                      placeholder="请输入名称"></el-input>
            <el-button class="ml10 mb10" type="primary" @click="getCustomer">搜索</el-button>
            <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-button class="ml10 mb10" type="primary" @click="toAdd">新增</el-button>
    <el-table
        :data="tableData"
        style="width: 100%;margin-bottom: 20px;"
        row-key="id"
        border>
      <el-table-column
          prop="name"
          align="center"
          label="分部名称"
      />
      <el-table-column
          prop="phone"
          align="center"
          label="账号"
      >
      </el-table-column>
      <el-table-column
          prop="liaison"
          align="center"
          label="联系人"
      />
      <el-table-column
          prop="createTime"
          align="center"
          label="创建时间"
      />
      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-popconfirm confirm-button-text="确定" cancel-button-text="取消"
                         @confirm="del(scope.row)" icon="el-icon-info" icon-color="red" title="确定要删除吗？">
            <el-button slot="reference" class="ml10" style="color: #fd634e" type="text">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pageBox">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 15, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          class=""
          :total="total"
          :pager-count="5"
      />
    </div>
  <add ref="add" @getList="getList"></add>
  </div>
</template>
<script>
import {selectBranchList,delBranch} from '@/api/storeBranch.js'
import Add from "./component/add.vue";
let baseUrl = process.env.VUE_APP_API_URL
export default {
  components: {Add},
  props: {},
  data() {
    let token = localStorage.getItem("token")
    return {
      uploadUrl: '/api/storeOrders/importExcel',
      upParams: {
        token: token
      },
      queryParam: {
        name: '',
      },
      tableData: [],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      dialogFormVisible: false,
      form: {
        id: '',
        name: '',
        intro: '',
        itemList: [],
        formula: ''
      },
      inputVisible: false,
      inputValue: '',
      rules: {

      }
    };
  },
  created() {
    this.getList()
  },
  methods: {
    toAdd(){
        this.$refs.add.init()
    },
    resetForm(){
      this.form.id = ''
      this.form.name = ''
      this.form.intro = ''
      this.form.formula = ''
      this.form.itemList = []
    },
    edit(row){
      this.$refs.add.edit(row)
    },
    del(row){
      delBranch(row.id).then(res=>{
        this.$message.success('删除成功')
        this.getList()
      })
    },
    resetFormula() {
      this.form.formula = ''
    },
    clickTag(tag) {
      this.form.formula = this.form.formula + tag
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    getCustomer() {
      this.getList()
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    },
    handleAddCode() {
      this.resetForm()
      this.dialogFormVisible = true
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      params = Object.assign(params, this.queryParam)
      selectBranchList(params).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },

    getTypeName() {

    },
    reset() {
      this.queryParam.name = ''
      this.getList()
    },
  }

}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.pageBox {
  display: flex;
  justify-content: flex-end;
}
</style>
